<template lang="pug">
  div.p-relative
    v-layout.grey.lighten-2.navigation-tree.justify-center
      rc-navigation-branch(v-for="item in menu" :key="item.route" ref="item" :menu="item" @toggle="value => { open = value }" @close="open = null; $emit('close'); closeAll()")
    div.fixed-nav-branch(v-if="open")
      rc-navigation-tree.embedded-nav(:menu="open.children" @close="open = null; $emit('close'); closeAll();")
</template>

<script>
import RcNavigationBranch from '@/components/RcNavigationBranch.vue';

export default {
  components: {
    RcNavigationBranch,
  },
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    baseRoutes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: null,
    }
  },
  mounted() {
    if (this.baseRoutes.includes(this.$route.name)) {
      this.openFirstBlock();
    }
  },
  methods: {
    closeAll() {
      this.$refs.item.map(it => { it.open = false; })
    },
    openFirstBlock(menu = this.menu) {
      return menu.some(it => {
        if (it.children && it.children.length) {
          if (this.openFirstBlock(it.children)) {
            return true;
          }
        } else if (this.hasCorrectRoles(it)) {
          this.$router.push({ name: it.route });
          return true;
        } else {
          return false;
        }
      });
    },
    hasCorrectRoles(branch) {
      return !branch.permissions || !branch.permissions.length || branch.permissions.every(it => !!this.$store.state.app.user.roles.find(x => x.name === it));
    },
  },
}
</script>

<style lang="scss">
  .embedded-nav {
    margin-top: 1px;
  }
  .fixed-nav-branch {
    position: absolute;
    width: 100%;
    z-index: 2;
  }
</style>
